/**
 * 404-pagina: speelt het opzoeken van het adres af in de console.
 *
 * Volgorde: commando typen, status tonen, een roulette langs echte sitepaden die
 * stilvalt op de beste match, daarna de suggesties regel voor regel. Alle tekst staat al
 * in de HTML; zonder JS, bij reduced motion of na een toets/klik staat de eindstand er direct.
 */
const TYPE_MS = 22;
const SPIN_MS = 70;
const SPIN_STEPS = 12;
const LINE_MS = 140;

export async function init() {
    const consoleEl = document.querySelector(".nf-console");
    if (!consoleEl) return;

    const finish = () => {
        consoleEl.classList.add("nf-done");
        window.removeEventListener("keydown", skip);
        window.removeEventListener("pointerdown", skip);
    };

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        finish();
        return;
    }

    const cmd = consoleEl.querySelector(".nf-cmd");
    const seek = consoleEl.querySelector(".nf-seek-path");
    const lines = [...consoleEl.querySelectorAll(".nf-line")];
    const [cmdLine, statusLine, seekLine] = lines;
    const paths = JSON.parse(consoleEl.dataset.nfPaths || "[]");
    const fullCommand = cmd?.dataset.text ?? "";
    const finalPath = seek?.textContent ?? "";

    let skipped = false;
    function skip() {
        skipped = true;
    }
    window.addEventListener("keydown", skip);
    window.addEventListener("pointerdown", skip);

    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    const show = (line) => line?.classList.add("is-in");

    try {
        if (cmd) cmd.textContent = "";
        show(cmdLine);

        for (let i = 1; i <= fullCommand.length && !skipped; i++) {
            cmd.textContent = fullCommand.slice(0, i);
            await wait(TYPE_MS);
        }
        if (cmd) cmd.textContent = fullCommand;

        if (!skipped) {
            show(statusLine);
            await wait(260);
        }

        if (!skipped) {
            show(seekLine);
            for (let i = 0; i < SPIN_STEPS && !skipped && paths.length > 1; i++) {
                seek.textContent = paths[i % (paths.length - 1)];
                await wait(SPIN_MS);
            }
        }
        if (seek) seek.textContent = finalPath;

        for (const line of lines.slice(3)) {
            if (skipped) break;
            show(line);
            await wait(LINE_MS);
        }
    } finally {
        finish();
    }
}
